"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _common = require("@scuf/common");

var _honeywellLogoRed = _interopRequireDefault(require("../../assets/honeywell-logo-red.svg"));

var _ApplicationContext = require("./ApplicationContext");

var _util = _interopRequireDefault(require("../common/util"));

var _NotificationHeader = _interopRequireDefault(require("./NotificationHeader"));

var _NotificationHeaderModal = _interopRequireDefault(require("./NotificationHeaderModal"));

var _reactHelmet = require("react-helmet");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A parent component to render the Login page
 */
var Login = /*#__PURE__*/function (_Component) {
  _inherits(Login, _Component);

  var _super = _createSuper(Login);

  function Login(props) {
    var _this;

    _classCallCheck(this, Login);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onUserNameChange", function (userName) {
      var form = _this.state.form;

      _this.setState({
        form: _objectSpread(_objectSpread({}, form), {}, {
          userName: userName
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPasswordChange", function (password) {
      var form = _this.state.form;

      _this.setState({
        form: _objectSpread(_objectSpread({}, form), {}, {
          password: password
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onNewPasswordChange", function (newPassword) {
      var form = _this.state.form;

      _this.setState({
        form: _objectSpread(_objectSpread({}, form), {}, {
          newPassword: newPassword
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onNewPasswordConfirmChange", function (newPasswordConfirm) {
      var form = _this.state.form;

      _this.setState({
        form: _objectSpread(_objectSpread({}, form), {}, {
          newPasswordConfirm: newPasswordConfirm
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this), "getErrorState", function () {
      var error = _this.state.error;

      if (error) {
        return 'Invalid username or password.';
      }

      return '';
    });

    _defineProperty(_assertThisInitialized(_this), "handleSubmit", /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event, context) {
        var form, _this$props, history, destination, updatePwd;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                form = _this.state.form;
                _this$props = _this.props, history = _this$props.history, destination = _this$props.destination;
                _context.prev = 2;
                _context.next = 5;
                return context.keystoneLogin(event, form);

              case 5:
                updatePwd = _context.sent;

                if (updatePwd === true) {
                  context.setNotification(null, null);

                  _this.setState({
                    open: true
                  });
                } else {
                  history.push(destination);
                }

                _context.next = 13;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                console.error(_context.t0);
                context.handleError(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 9]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "isPasswordMatching", function (form) {
      if (form.newPassword === form.newPasswordConfirm) {
        return true;
      }

      return false;
    });

    _this.state = {
      form: {
        userName: null,
        password: null,
        newPassword: null,
        newPasswordConfirm: null
      },
      error: false,
      open: false,
      loadingSettings: false,
      cookieLoginFailed: false
    };
    return _this;
  }

  _createClass(Login, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this$props2, history, destination, _this$context, cookieLogin, notification, setNotification, setNotificationModal, cookieLoginResult, script;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$props2 = this.props, history = _this$props2.history, destination = _this$props2.destination;
                _this$context = this.context, cookieLogin = _this$context.cookieLogin, notification = _this$context.notification, setNotification = _this$context.setNotification, setNotificationModal = _this$context.setNotificationModal; // try to log in with JWT cookie

                _context2.next = 4;
                return cookieLogin();

              case 4:
                cookieLoginResult = _context2.sent;

                if (cookieLoginResult) {
                  // if cookie login successful, go to destination page
                  history.push(destination);
                } else {
                  // if cookie login failed, load page components for username/password
                  this.setState({
                    cookieLoginFailed: true
                  });
                }

                if (notification.carryForward === false) {
                  setNotification(null);
                }

                setNotificationModal(null); //set cookie consent banner

                script = document.createElement("");

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "toggleLoading",
    value: function toggleLoading() {
      this.setState(function (prevState) {
        return {
          loadingSettings: !prevState.loadingSettings
        };
      });
    }
  }, {
    key: "renderLoginPage",
    value: function renderLoginPage() {
      var _this2 = this;

      var history = this.props.history;
      var notification = this.context.notification;
      return /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, this.renderUpdatePasswordModal())), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 3,
        mWidth: 3,
        sWidth: 2,
        xsWidth: 0
      }), /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 6,
        mWidth: 6,
        sWidth: 8,
        xsWidth: 12
      }, /*#__PURE__*/_react["default"].createElement("form", {
        onSubmit: function onSubmit(event) {
          _this2.handleSubmit(event, _this2.context);
        }
      }, /*#__PURE__*/_react["default"].createElement(_common.Card, null, /*#__PURE__*/_react["default"].createElement(_common.Card.Header, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement("img", {
        src: _honeywellLogoRed["default"],
        alt: "Honeywell Logo",
        id: "LoginLogo",
        className: "center"
      }))), /*#__PURE__*/_react["default"].createElement(_common.Card.Content, null, /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "error-block alert-danger"
      }, notification.hasNotification ? /*#__PURE__*/_react["default"].createElement(_NotificationHeader["default"], null) : ''), /*#__PURE__*/_react["default"].createElement("br", null)), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_common.Input, {
        fluid: true,
        type: "text",
        label: "Username",
        placeholder: "name@email.com",
        onChange: function onChange(username) {
          return _this2.onUserNameChange(username);
        }
      })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_common.Input, {
        fluid: true,
        type: "password",
        label: "Password",
        placeholder: "password",
        onChange: function onChange(password) {
          return _this2.onPasswordChange(password);
        }
      })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_reactBootstrap.FormGroup, null, /*#__PURE__*/_react["default"].createElement(_common.Button, {
        type: "primary",
        className: "btn-block",
        iconPosition: "right",
        onClick: function onClick(event) {
          _this2.handleSubmit(event, _this2.context);
        },
        actionType: "submit"
      }, "Login"), /*#__PURE__*/_react["default"].createElement(_common.Button, {
        type: "link",
        onClick: function onClick() {
          history.push('/reset-password');
        }
      }, "Reset Password"))), /*#__PURE__*/_react["default"].createElement(_common.Card.Footer, {
        align: "left",
        className: "login-footer"
      }, _util["default"].showRegisterAccountLink() ? /*#__PURE__*/_react["default"].createElement(_common.Button, {
        className: "login-footer-link",
        type: "link",
        onClick: function onClick() {
          history.push('/register-new-account');
        }
      }, "Register New Account") : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), /*#__PURE__*/_react["default"].createElement(_common.Popup, {
        element: /*#__PURE__*/_react["default"].createElement(_common.Button, {
          type: "link",
          className: "login-footer-link"
        }, "Contact Support"),
        position: "right center",
        hideOnScroll: true
      }, /*#__PURE__*/_react["default"].createElement(_common.Card, null, /*#__PURE__*/_react["default"].createElement(_common.Card.Content, null, "Need help with login? Contact: ", _util["default"].getSupportEmail(), ' ', _util["default"].getSupportPhone()))))))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        xlWidth: 4,
        lWidth: 3,
        mWidth: 3,
        sWidth: 2,
        xsWidth: 0
      })), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("script", {
        type: "text/javascript",
        src: "https://cdn.cookielaw.org/consent/39b417aa-dc6f-4ca0-9a2d-ace4c5ba39ef/OtAutoBlock.js"
      }), /*#__PURE__*/_react["default"].createElement("script", {
        src: "https://cdn.cookielaw.org/scripttemplates/otSDKStub.js",
        "data-document-language": "true",
        type: "text/javascript",
        charset: "UTF-8",
        "data-domain-script": "39b417aa-dc6f-4ca0-9a2d-ace4c5ba39ef"
      }), /*#__PURE__*/_react["default"].createElement("script", {
        type: "text/javascript"
      }, "function OptanonWrapper() ")))));
    }
  }, {
    key: "renderUpdatePasswordModal",
    value: function renderUpdatePasswordModal() {
      var _this3 = this;

      var _this$context2 = this.context,
          notificationModal = _this$context2.notificationModal,
          updatePassword = _this$context2.updatePassword,
          handleModalError = _this$context2.handleModalError;
      var _this$state = this.state,
          open = _this$state.open,
          hasDimmer = _this$state.hasDimmer,
          loadingSettings = _this$state.loadingSettings,
          form = _this$state.form;
      var _this$props3 = this.props,
          history = _this$props3.history,
          destination = _this$props3.destination;
      return /*#__PURE__*/_react["default"].createElement(_common.Modal, {
        onClose: function onClose() {
          return _this3.setState({
            open: false
          });
        },
        open: open,
        dimmer: hasDimmer,
        closeOnDimmerClick: false,
        size: "small"
      }, /*#__PURE__*/_react["default"].createElement(_common.Modal.Content, null, notificationModal.hasNotification ? /*#__PURE__*/_react["default"].createElement(_NotificationHeaderModal["default"], {
        context: this.context
      }) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null), /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement("h1", null, "Update Password"))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.Loader, {
        loading: loadingSettings,
        overlayOpacity: 0.2,
        overlayColor: "#B2AFAF"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "placeholder"
      })))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.InputLabel, {
        label: "New Password",
        indicator: "required"
      }))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 10
      }, /*#__PURE__*/_react["default"].createElement(_common.Input, {
        fluid: true,
        error: null,
        type: "password",
        maxLength: "30",
        placeholder: "Password",
        onChange: function onChange(data) {
          return _this3.onNewPasswordChange(data);
        }
      })), /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 2
      }, /*#__PURE__*/_react["default"].createElement(_common.Icon, {
        name: "badge-info",
        root: "common",
        description: "Length should be in between 8 to 30 characters, Minimum 1 character should be uppercase, Minimum 1 character should be number, Minimum 1 character should be special, No sequential 3 numbers like '123' or '234'."
      })))))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 12
      }, /*#__PURE__*/_react["default"].createElement(_common.Grid, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 10
      }, /*#__PURE__*/_react["default"].createElement(_common.InputLabel, {
        label: "Confirm Password",
        indicator: "required"
      }))), /*#__PURE__*/_react["default"].createElement(_common.Grid.Row, null, /*#__PURE__*/_react["default"].createElement(_common.Grid.Column, {
        width: 10
      }, /*#__PURE__*/_react["default"].createElement(_common.Input, {
        fluid: true,
        error: null,
        type: "password",
        maxLength: "30",
        placeholder: "Confirm Password",
        onChange: function onChange(data) {
          return _this3.onNewPasswordConfirmChange(data);
        }
      })))))))), /*#__PURE__*/_react["default"].createElement(_common.Modal.Footer, null, /*#__PURE__*/_react["default"].createElement(_common.Button, {
        type: "primary",
        content: "Submit",
        size: "small",
        onClick: /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var isPwdMatching, response;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  isPwdMatching = _this3.isPasswordMatching(form);

                  if (!(isPwdMatching === true)) {
                    _context3.next = 10;
                    break;
                  }

                  _this3.toggleLoading();

                  _context3.next = 5;
                  return updatePassword(form);

                case 5:
                  response = _context3.sent;

                  _this3.toggleLoading();

                  if (!(response instanceof Error)) {
                    _this3.setState({
                      open: false
                    });

                    history.push(destination);
                  }

                  _context3.next = 11;
                  break;

                case 10:
                  handleModalError(new Error('Passwords do not match.'));

                case 11:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }))
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var login = this.context.login;
      var cookieLoginFailed = this.state.cookieLoginFailed;

      if (_util["default"].getSentienceEnableFlag()) {
        login();
      } else if (cookieLoginFailed) {
        return this.renderLoginPage();
      }

      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Loading...");
    }
  }]);

  return Login;
}(_react.Component);

Login.contextType = _ApplicationContext.AppContext;
Login.propTypes = {
  destination: _propTypes["default"].string,
  history: _propTypes["default"].shape({
    push: _propTypes["default"].func
  }).isRequired
};
Login.defaultProps = {
  destination: '/home'
};
var _default = Login;
exports["default"] = _default;